<template>
  <div class="row mr-2">
    <v-spacer></v-spacer>
    <v-file-input
      style="padding-top: 0"
      :label="uploadFieldLabel"
      ref="file"
      @change="fileUpload()"
      single-line
      hide-details
    ></v-file-input>
    <v-btn @click="submitFile()" :disabled="!file" class="ml-2" color="primary">Upload</v-btn>
  </div>
</template>
<script>
export default {
  props: {
    uploadFieldLabel: {
      type: String,
      default: 'Select file'
    },
    inputName: {
      type: String,
      default: 'file'
    }
  },
  data () {
    return {
      file: null
    }
  },
  methods: {
    // Upload file on component
    fileUpload () {
      this.file = this.$refs.file.lazyValue
    },

    // Upload to BE
    submitFile () {
      console.log('submitFile')
      var reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = () => {
        console.log(reader.result)
        this.$emit('file-submitted', reader.result)
      }
    }
  }
}
</script>
